import React from "react";
import { PageLayout, PageContent, PageHeader } from "../../ui";
import { EvaluationsView } from "./components/EvaluationsView";

export default function InsightsPage() {
  return (
    <PageLayout>
      <PageContent maxWidth="full">
        <PageHeader
          title="Evaluations Insights"
          description="Filter and analyze your evaluation data with advanced tag filtering and comparison tools"
        />
        <EvaluationsView />
      </PageContent>
    </PageLayout>
  );
}
